export abstract class FormatterBasic {
    public Field:FieldDTO;
    public Data:any;
    constructor() {
    }

    public Initialize(field:FieldDTO,data:any)
    {
        this.Field=field;
        this.Data=data;
        return this;
    }

    public GetValue(propertyName:string){
        if(this.Data[propertyName]!=null)
            return this.Data[propertyName];
        return '';
    }

    public abstract Format():string;

}